import React, { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import PageFactory, { PageToobarFactory } from "./page.factory";
import usePage from "../../hooks/usePage";
import Utils from "../../utils/functions";
import useQueryResource from "../../hooks/useQueryResource";

export const PageContext = createContext();

const CpdContentPage = ({
  pathname,
  pageToolBarLandingTitle,
  pageToolBarLandingSubTitle,
  pageToolBarLandingLabel,
  pageToolBarDetailsTitle = null,
  pageToolBarDetailsSubTitle,
  pageToolBarNewTitle = null,
  pageToolBarNewSubTitle,
  defaultStorageStateKey,
  children,
}) => {
  const location = useLocation();
  const paths = location.pathname.split("/");

  const [pathIndex, setPathIndex] = useState(3);
  const [matchedPage] = usePage(paths[pathIndex]);

  const { loading: pageLoading, setLoading } = useContext(PageContext);

  const resourceName = Utils.toLowerCase(paths[3]);
  // Normalise API pathNames for consistent pathname structure.
  const urlPath =
    resourceName === "cases"
      ? "cpd/cases"
      : resourceName === "nodes"
      ? "cpd/idl/nodes"
      : resourceName === "courses"
      ? "cpd/courses"
      : resourceName;
  const {
    data: resources,
    loading,
    // refetch,
    // error,
  } = useQueryResource(urlPath, resourceName);

  useEffect(() => {
    setPathIndex(paths.length - 1);
  }, [paths, pathIndex]);

  return (
    <PageFactory
      pageView={matchedPage}
      resource={resourceName}
      toolBar={() => (
        <PageToobarFactory
          pageView={matchedPage}
          toolBarLanding={() => <React.Fragment></React.Fragment>}
          toolBarDetails={() => <React.Fragment></React.Fragment>}
          toolBarNew={() => <React.Fragment></React.Fragment>}
        />
      )}
      resources={resources}
      pathname={pathname}
      loading={loading || pageLoading}
      setLoading={setLoading}
    >
      {children}
    </PageFactory>
  );
};

export default CpdContentPage;
